/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import e from"./Message.js";class t extends e{constructor(e,s,r){if(super(e,s,r),!(this instanceof t))return new t(e,s,r)}}t.prototype.type="warning";export{t as default};
